import BrandsSlider from "./components/brands-slider";
import CallToAction from "./components/call-to-action";
import ComparisonCards from "./components/comparison-cards";
import Faq from "./components/faq";
import FinishesColors from "./components/finishes-colors";
import FinishesCardsLayout from "./components/finishes-layout";
import FinishesSlider from "./components/finishes-slider";
import MaterialsCard from "./components/materials-card";
import PartsSlider from "./components/parts-slider";
import SetBgColor from "./components/set-bg-color";
import CheckAndRemoveClasses from "./components/newsletter";
import HowItWorksSlider from "./components/how-it-works-slider";
import HowItWorksSteps from "./components/how-it-works-steps";
import MaterialCards from "./components/material-cards";
import MaterialCardsSlider from "./components/material-cards-slider";
import Selects from "./components/selects";
import CapabilityCards from "./components/capability-cards";
import ComparisonTable from "./components/comparison-table";
import CapabilityTable from "./components/capability-table";
import ProcessSlider from "./components/process-slider";
import Accordion from "./components/accordion";
import CapabilityIconsSlider from "./components/capability-icons-slider";
import Ticker from "./components/ticker";
import BrandsTooltip from "./components/brands-tooltip";
import CasesList from "./components/cases-list";
import CasesFilters from "./components/cases-filters";
import ThreeSlidesSlider from "./components/three-slides-slider";
import ArticleToc from "./components/article-toc";
import ArticleNavigation from "./components/article-navigation";
import initArticleSliders from "./components/article-slider";
import ServiceTabs from "./components/tabs";
import Marquee from "./components/marquee";
import ShowcaseVideo from "./components/showcase";
import MediaCenter from "./components/media-center";

document.addEventListener("DOMContentLoaded", function () {
  BrandsSlider();
  ComparisonCards();
  CallToAction();
  MaterialsCard();
  FinishesSlider();
  SetBgColor();
  FinishesColors();
  PartsSlider();
  Faq();
  ThreeSlidesSlider();
  CheckAndRemoveClasses();
  FinishesCardsLayout();
  HowItWorksSlider();
  HowItWorksSteps();
  MaterialCards();
  MaterialCardsSlider();
  Selects();
  CapabilityCards();
  ComparisonTable();
  CapabilityTable();
  ProcessSlider();
  CapabilityIconsSlider();
  Ticker();
  BrandsTooltip();
  CasesList();
  // CasesFilters();
  ArticleToc();
  ArticleNavigation();
  initArticleSliders();
  Accordion();
  ServiceTabs();
  Marquee();
  ShowcaseVideo();
  new MediaCenter();
});

document.addEventListener('DOMContentLoaded', () => {
  const root = document.getElementById('casesRoot');
  if (!root) return;

  Promise.all([
    import(/* webpackChunkName: "ui-selects" */ './components/selects'),
    import(/* webpackChunkName: "cases-filters" */ './components/cases-filters'),
  ]).then(([{ default: Selects }, { default: initCasesFilters }]) => {
    Selects();                 // сначала Select2 + событие cases:filters:changed
    initCasesFilters(root);    // затем AJAX слушатель
  });
});